import { memo, useEffect, useState } from "react";
import useOrangeHeader from "app/utils/hooks/useOrangeHeader";
import "./Header.scss";
import axios from "axios";

const Header = () => {
	const [menu, setMenu] = useState();

	useOrangeHeader({ display: true });

	useEffect(() => {
		axios
			.get("https://tendances.orange.fr/esi/menu.html?absolutePath=1&includeAssetsRootSize=1")
			.then(response => {
				setMenu(response.data);
			});
	});

	return (
		<div className="header-orange">
			<header id="o-header" />
			<div dangerouslySetInnerHTML={{ __html: menu }} />
		</div>
	);
};

export default memo(Header);
